<template>
	<v-combobox
		v-model="model"
		:items="items"
		:label="label"
		:outlined="outlined"
		:dense="dense"
		item-text="name"
		item-value="id"
		:hide-details="hideDetails"
		:clearable="clearable"
		:loading="loading"
		:rules="rules"
		return-object
	>
		<template v-slot:item="{ on, item }">
			<v-list-item v-on="on">
				<v-list-item-icon>
					<v-icon :color="item.code">mdi-square</v-icon>
				</v-list-item-icon>
				<v-list-item-content>
					<v-list-item-title>{{ item.name }}</v-list-item-title>
				</v-list-item-content>
			</v-list-item>
		</template>
		<template v-slot:append>
			<v-icon :color="model.code" v-if="model && model.hasOwnProperty('code')">mdi-square</v-icon>
		</template>
	</v-combobox>
</template>

<script>
import mixin from './mixin/main'
import { mapGetters, mapActions } from 'vuex'
export default {
	mixins: [mixin],
	computed: {
		...mapGetters('VehicleColor', [ 'items' ]),
	},
	methods: {
		...mapActions('VehicleColor', [ 'load' ]),
	},
}
</script>